import { z } from '@harvestiq/zod';

export const submitAipCoverageReqSchema = z.object({
  coverageId: z.string().uuid(),
});
export type SubmitAipCoverageReq = z.infer<typeof submitAipCoverageReqSchema>;
